// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 138 ? "webgl-supply" : chunkId) + "-modern." + {"26":"27671528af85dd1e23ac","104":"84ce3e9f2ea49b432667","106":"760246d9472ce2f938a8","138":"cf29523ff892fd15f509","196":"d0571798e6d5b1b1d9a4","624":"c7d666370a02af6208c8","657":"64af22f721f060e1bd44"}[chunkId] + ".chunk.js";
};